import { MainLoader } from "@/components/loader/MainLoader"
import { useAuthContext } from "@/context-state/AuthContext"
import { useEffect } from "react"
import * as API from "@/services/api"
import { toast } from "sonner"
import { useParams } from "react-router-dom"

export const AccountMembersDataProvider = ({ children }) => {
    const { setAccountUsers, getAccountUsers } = useAuthContext()

    const { accountId } = useParams()
    const accountUsers = getAccountUsers(accountId)

    const fetchAccountUsers = async () => {
        try {
            const { data } = await API.getAccountUsers(accountId)
            setAccountUsers(accountId, data)
        } catch (e) {
            console.error(e)
            toast.error('Failed to fetch account users')
        }
    }

    useEffect(() => {
        if (!accountUsers.length) {
            fetchAccountUsers()
        }
    }, [])

    return accountUsers?.length ? children : <MainLoader className="bg-hero-background bg-cover bg-center bg-no-repeat" />
}